import { UTCDateMini } from "@date-fns/utc";
import endOfDay from "date-fns/endOfDay";
import dateFnsParse from "date-fns/parse";
import sub from "date-fns/sub";
import {
  format as dateFnsFormat,
  utcToZonedTime as dateFnsUtcToZonedTime,
} from "date-fns-tz";

/*** @deprecated - implementations for these functionality should use Luxon */
export const iso8601 = "yyyy-MM-dd'T'HH:mm:ss'Z'";

/*** @deprecated - implementations for these functionality should use Luxon */
export const iso8601WithoutTz = "yyyy-MM-dd'T'HH:mm:ss";
/*** @deprecated - implementations for these functionality should use Luxon */
export const DATE_ONLY_FORMAT = "yyyy-MM-dd";
/*** @deprecated - implementations for these functionality should use Luxon */
export function zonedTimeToUtc(date: string, fromTz: string, format = iso8601) {
  const parsedForReference = dateFnsParse(date, iso8601WithoutTz, new Date());
  const offset = formatInTimeZone(parsedForReference, "xxx", fromTz);
  const parsed = dateFnsParse(
    `${date}${offset}`,
    "yyyy-MM-dd'T'HH:mm:ssxxx",
    new UTCDateMini(),
  );
  const result = formatInTimeZone(parsed, format, "UTC");

  return result;
}

/*** @deprecated - implementations for these functionality should use Luxon */
export function utcToZonedTime<T extends string | undefined>(
  date: T,
  toTz: string,
  format = iso8601WithoutTz,
) {
  if (date === undefined) return undefined as T;
  const parsed = dateFnsParse(
    date,
    "yyyy-MM-dd'T'HH:mm:ssxxx",
    new UTCDateMini(),
  );
  const zonedDate = dateFnsUtcToZonedTime(parsed, toTz);
  const zonedTimeString = dateFnsFormat(zonedDate, iso8601WithoutTz, {
    timeZone: "UTC",
  });
  return zonedTimeString as T;
}

/*** @deprecated - implementations for these functionality should use Luxon */
const formatInTimeZone = (date: Date, fmt: string, tz: string) => {
  return dateFnsFormat(dateFnsUtcToZonedTime(date, tz), fmt, { timeZone: tz });
};

/*** @deprecated - implementations for these functionality should use Luxon */
export function zonedTime(timezone: string, utcDate: Date = new UTCDateMini()) {
  const utc = formatInTimeZone(utcDate, iso8601, "UTC");
  return utcToZonedTime(utc, timezone);
}

/*** @deprecated - implementations for these functionality should use Luxon */
export function dateStringToDate(
  dateString: string,
  format = iso8601WithoutTz,
) {
  return dateFnsParse(dateString, format, new Date());
}

/*** @deprecated - implementations for these functionality should use Luxon */
export function lastSecondOfYesterday(
  timezone: string,
  format = iso8601WithoutTz,
) {
  const result = dateFnsFormat(
    endOfDay(sub(dateStringToDate(zonedTime(timezone)), { days: 1 })),
    format,
  );
  return result;
}
